import { render } from "./SubstepTranslation.vue?vue&type=template&id=98da7406&scoped=true"
import script from "./SubstepTranslation.vue?vue&type=script&lang=js"
export * from "./SubstepTranslation.vue?vue&type=script&lang=js"

import "./SubstepTranslation.vue?vue&type=style&index=0&id=98da7406&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98da7406"]])

export default __exports__